// extracted by mini-css-extract-plugin
module.exports = {"tp":"tooltip_tp__NVWC9","tooltip__trigger__mob":"tooltip_tooltip__trigger__mob__rwiST","tooltip__trigger__web":"tooltip_tooltip__trigger__web__RPXf7"};